import { Directive, HostListener, Input } from "@angular/core";
import { GaEvent } from "@edp-models/datalayer.model";
import { DatalayerService } from "@edp-services/datalayer.service";

@Directive({
    selector: "[gaEventDatalayer]",
})
export class GaEventDirective {
    @Input() gaEventDatalayer: string;
    @Input() extraGaEventDatalayer = null;

    constructor(private datalayerService: DatalayerService) {}

    @HostListener("click", ["$event"]) onClick($event: { preventDefault: () => void }) {
        this.datalayerService.setGaEvent(this.gaEventDatalayer, this.extraGaEventDatalayer);
    }
}
